import axios from 'axios';
import { unescape } from './utils';

const createRemoteDataProvider = (remote, wildcard) => (query) => {
    // remote может содержать html-сущности
    const urlTemplate = unescape(remote);
    const url = urlTemplate.replace(wildcard, encodeURIComponent(query));
    return axios.get(url).then((response) => response.data);
};

export default createRemoteDataProvider;
